import { connect } from 'react-redux';

import {
  getEventsGroupColumn,
  getEventIds,
  getEventName,
  getMetainf,
} from '../../reducers/analyticsApp';
import { usageEvents } from '../../constants/event';
import { prepareDropdown } from '../../utils/common';
import EventsFieldOption from '../../components/event/FieldOption';
import { groupByExcludeFields } from '../../constants/metainf';
import { setEventsGroupColumn } from '../../actions/events/csvEvents';

const mapStateToProps = (state, { id }) => {
  const eventIds = getEventIds(state);

  const usageEventIds = eventIds.filter((idItem) => {
    const name = getEventName(state, idItem);
    return !!usageEvents[name];
  });

  const visible = !usageEventIds.includes(id);

  if (!visible) {
    return {
      visible,
    };
  }

  // In case some of events is usage event
  // we are not able to change group column
  // It equals to the default one for that
  // usage event
  const disabled = usageEventIds.length > 0;

  const uniqEventNames = Array.from(
    new Set(eventIds.map((idItem) => getEventName(state, idItem)).filter((name) => !!name))
  );

  // In case we have more than one uniq event name
  // we must display only common fields (attributes)
  const eventName = disabled || uniqEventNames.length > 1 ? undefined : getEventName(state, id);

  const metainf = getMetainf(state, eventName);
  const fields = prepareDropdown(metainf, false, groupByExcludeFields);

  return {
    label: 'Group by:',
    value: getEventsGroupColumn(state),
    values: fields,
    disabled,
    visible: true,
    allowClear: false,
  };
};

const mapDispatchToProps = {
  onChange: setEventsGroupColumn,
};

const EventsGroupByFieldOption = connect(mapStateToProps, mapDispatchToProps)(EventsFieldOption);

export default EventsGroupByFieldOption;
